export default "__VITE_ASSET__DD9u8EDI__"